const validationEndPoint = {
  AGREEMENTPATH: 'erm/validate/subscriptionAgreement'
};

export default validationEndPoint;
